import { XIcon } from "@heroicons/react/outline";
import { Search } from "lucide-react";
import React from "react";

import LoadingSpinner from "@/components/LoadingSpinner";
import { Button } from "@/components/ui/button";
import { CommandInput } from "@/components/ui/command";

interface SearchHeaderProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onClear: () => void;
  isLoading?: boolean;
}

export const SearchHeader: React.FC<SearchHeaderProps> = ({
  searchQuery,
  onSearchChange,
  onClear,
  isLoading = false,
}) => (
  <div className="flex items-center border-b px-4 py-3">
    {isLoading ? (
      <LoadingSpinner size="4" className="shrink-0 " />
    ) : (
      <Search className="h-4 w-4 shrink-0 text-muted-foreground" />
    )}
    <div className="relative flex w-full items-center">
      <CommandInput
        placeholder="Search or jump to..."
        value={searchQuery}
        onValueChange={onSearchChange}
      />
      {searchQuery && (
        <Button
          onClick={onClear}
          variant="ghost"
          size="tinyIcon"
          className="absolute right-2 z-[1] rounded-full"
          aria-label="Clear search"
        >
          <XIcon className="h-4 w-4 text-muted-foreground transition-colors hover:text-foreground" />
        </Button>
      )}
    </div>
  </div>
);
